import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    ReactiveFormsModule,
  ],
  declarations: [

  ],
  exports: [
  ]
})
export class NgSharedModule { }
